export default {
  name: 'dn-navigation-tag',

  props: {
    tag: {
      type: String,
      default: 'span',
    },
    color: {
      type: String,
      default: 'default',
    },
    lg: Boolean,
  },

  computed: {
    label() {
      const slots = this.$slots.default;
      const text = slots && slots[0] && slots[0].text || '';
      const length = text.length;
      const created = text.split('').join('<i class="dn-navigation-tag__spacer"></i>');
      return {
        text,
        created,
        length,
      }
    },
  },

  render(h) {
    const { label } = this;
    return h(this.tag, {
      staticClass: 'dn-navigation-tag',
      class: {
        ['dn-navigation-tag--' + this.color]: true,
        ['dn-navigation-tag--length-' + label.length]: true,
        'dn-navigation-tag--lg': this.lg,
      },
      domProps: {
        innerHTML: label.created,
      },
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/NavigationTag.js